export default __webpack_public_path__ + "static/media/city.c43de23c.png";